export default async <T, B>(
  url: string,
  options: {
    method?: 'GET' | 'POST',
    body?: B,
    headers?: any,
    timeout?: number
  } = {}
): Promise<T | { error: string }> => {
  const {
    method = 'GET',
    body = undefined,
    headers = {},
    timeout = 5000
  } = options;
  const controller = new AbortController();
  const hdrs = {
    'Content-type': 'application/json',
    ...headers
  };
  const requestInit: RequestInit = {
    method: method.toUpperCase(),
    signal: controller.signal,
    body: typeof body === 'object' ? JSON.stringify(body) : undefined,
    mode: 'cors',
    headers: hdrs
  };
  setTimeout(() => controller.abort(), timeout);
  try {
    const res = await fetch(`${url}`, requestInit);
    const responsePayload = await res.json();
    if (!res.ok) {
      return { error: responsePayload.code };
    }
    return responsePayload;
  } catch (err) {
    return { error: `${err}` };
  } finally {
    controller.abort();
  }
};
